<template>
  <section id="mainContainer">
    <adminHeader></adminHeader>
    <section class="admin-mid-container">
      <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
        <adminNavigation></adminNavigation>
        <section class="admin-right-sidebar">
          <div class="admin-right-sidebar-in">
            <div class="admin-right-sidebar-in-top">
              <div class="admin-custom-row">
                <div class="admin-right-sidebar-in-top-left">
                  <h1>{{ constants.MANAGE_ARTICLES_TEXT }}</h1>
                  <div class="admin-page-type-links">
                    <ul>
                      <li>
                        <a id="allLink" href="#" :class="{ active: activeTab === 'all' }" @click="switchView('all')">
                          {{ constants.ALL_LINK }}
                          <span>{{ counts.all }}</span>
                        </a>
                      </li>
                      <li>
                        <a id="publishedhLink" href="#" :class="{ active: activeTab === 'published' }"
                          @click="switchView('published')">
                          {{ constants.PUBLISHED_LINK }}
                          <span>{{ counts.published }}</span>
                        </a>
                      </li>
                      <li>
                        <a id="unPublishedhLink" href="#" :class="{ active: activeTab === 'unpublished' }"
                          @click="switchView('unpublished')">
                          {{ constants.UNPUBLISHED_LINK }}
                          <span>{{ counts.unpublished }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="admin-right-sidebar-in-top-right">
                  <div class="admin-right-sidebar-in-top-right-top">
                    <div class="admin-search-box">
                      <input id="seachArticlesInput" type="text" placeholder="Search" v-model="searchedText"
                        @keyup.enter="fetchArticles(activeTab), fetchCounts(searchedText)" />
                    </div>
                    <div class="admin-add-btn">
                      <button id="addArticleBtn" class="add-btn-admin" :class="{ 'active': showAddForm }"
                        @click="showAddForm = true, selectedArticles = [], selectAll = false, cancelEdit()">
                        <i class="add-icon"></i>
                        {{ constants.ADD_ARTICLE_BUTTON }}
                      </button>
                    </div>
                  </div>
                  <div class="admin-right-sidebar-in-top-right-btm" v-if="selectedArticles.length > 1">
                    <div class="tags">
                      <ul>
                        <li>
                          <span>{{ selectedArticles.length }} entries selected</span>
                          <button id="tagCloseBtn" @click="selectedArticles = [], selectAll = false"></button>
                        </li>
                      </ul>
                    </div>
                    <div class="delete-all-btn-link">
                      <button class="btn_link" id="deleteAllBtn" data-bs-toggle="modal" data-bs-target="#deletePop"
                        @click="setDeleteMode('all')">
                        {{ constants.DELETE_ALL_BUTTON }}
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div v-if="showAddForm" class="white-bg-border add-new-section">
              <div class="add-banner-image-section">
                <h2>{{ constants.ADD_NEW_ARTICLE_TEXT }}</h2>
                <div class="add-banner-image-box">
                  <form id="addArticleForm" @submit.prevent="submitForm">
                    <div class="admin-input-field">
                      <label>{{ constants.TITLE_LABEL }}</label>
                      <input id="articleTitleInput" type="text" v-model="newArticle.title"
                        placeholder="Enter the Title" />
                      <div class="error-msg" v-if="!newArticle.title">{{ errMsg }}</div>
                    </div>
                    <div class="admin-input-field">
                      <label>{{ constants.DESCRIPTION_LABEL }}</label>
                      <ckeditor placeholder="Description" class="text-editer" id="articleDescInput" :editor="editor"
                        v-model="newArticle.description" :config="Config"></ckeditor>
                      <div class="error-msg" v-if="!newArticle.description">{{ errMsg }}</div>
                    </div>
                    <div class="admin-input-field">
                      <label>
                        {{ constants.Article_IMAGE_LABEL }}
                      </label>
                      <div class="image-upload-input upload-banner-image">
                        <div :class="['image-upload-input-item', { 'uploaded-done': imageUploaded }]">
                          <div class="file-input-box">
                            <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                              @click="clearUploadedImage(false)"></button>
                            <input id="addArticlefileInput" @change="handleFileUpload($event, false)" accept="image/jpeg,image/jpg,image/png"
                              type="file">
                          </div>
                          <div class="image-upload-input-item-in" v-if="!imageUploaded">
                            <div class="image-upload-input-item-icon">
                              <img src="@/assets/images/admin-img/image-icon.svg" alt="" class="">
                            </div>
                            <span>
                              {{ constants.ADD_ARTICLE_IMAGE_LABEL }}
                            </span>
                          </div>
                          <div class="image-upload-input-item-uploaded" v-if="imageUploaded">
                            <img :src="imageUrl" alt="" class="mCS_img_loaded">
                          </div>
                        </div>
                      </div>
                      <div class="error-msg" v-if="!selectedFile">{{ errMsg }}</div>
                    </div>
                    <div class="admin-input-field-submit">
                      <button id="articlefileInput" type="submit" class="admin-btn-outline-primary add-new-cancel" :disabled="isSubmitting">{{
                        constants.SUBMIT_BUTTON
                        }}</button>
                      <button id="articleCancelBtn" type="button" class="admin-btn-outline-secondary add-new-cancel"
                        @click="resetForm">{{
                          constants.CANCEL_BUTTON }}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div
              :class="['admin-item-list-section banner-image-section', { 'show-edit-item-outer': editFormSubmitted }]"
              v-if="editArticlesData.length > 0">

              <div class="admin-item-list-section-in" ref="scrollWrapper" data-simplebar>
                <div class="admin-item-list-section-scroll">
                  <div class="admin-item-list-top">
                    <div class="admin-item-list-row">
                      <div class="admin-item-checkbox">
                        <div class="admin-checkbox-input">
                          <input name="cssCheckbox" id="selectAll" type="checkbox" class="css-checkbox"
                            @change="toggleSelectAll" :checked="selectAll === true">
                          <label for="selectAll"></label>
                        </div>
                      </div>
                      <div class="admin-item-banner-image">{{ constants.Article_IMAGE_LABEL }}</div>
                      <div class="admin-item-page-name" @click="toggleSort('title')" style="cursor: pointer;">{{ constants.TITLE_LABEL }}
                        <button v-if="sortBy === 'title' || sortBy === '-title'" class="sorting-btn" :class="{ 'sorted': sortBy === '-title' }">
                        </button>
                      
                      </div>
                      <div class="admin-item-title" @click="toggleSort('description')" style="cursor: pointer;">{{ constants.DESCRIPTION_LABEL }}
                      
                        <button v-if="sortBy === 'description' || sortBy === '-description'" class="sorting-btn" :class="{ 'sorted': sortBy === '-description' }">
                        </button>
                      
                      </div>
                      <div class="admin-item-actions">{{ constants.ACTIONS_LABEL }}</div>
                    </div>
                  </div>
                  <div class="admin-item-list-btm">
                    <div ref="sortableList"> 
                    <div v-for="(article, index) in editArticlesData" :key="article.id"
                      :class="['admin-item-box', { 'show-edit-item': article.editing }]">
                      <div class="admin-item-box-top">
                        <div class="admin-item-list-row">
                          <div class="admin-item-checkbox">
                            <div class="admin-checkbox-input">
                              <input name="cssCheckbox" :id="'demo_opt_' + article.id" type="checkbox"
                                class="css-checkbox" @change="toggleArticleSelection(article.slug)"
                                :checked="selectedArticles.includes(article.slug)">
                              <label :for="'demo_opt_' + article.id"></label>
                            </div>
                          </div>
                          <div class="admin-item-banner-image">
                            <div class="admin-item-banner-image-box">
                              <img :src="getCdnImageAddress(article.articleImage , `w_76,h_37/`) || '@/assets/images/admin-img/demo-img/item-img-1.jpg'"
                                alt="" />
                            </div>
                          </div>
                          <div class="admin-item-page-name text-limit">{{ article.title }}</div>
                          <div class="admin-item-title text-limit">
                            {{ useStripHtml(article.description) }}
                          </div>
                          <div class="admin-item-actions">
                            <ul class="admin-action-link">
                              <li><button id="articlePgEditBtn" class="editBtn" @click="editArticle(index), showAddForm = false">{{
                                constants.EDIT_BUTTON
                                  }}</button></li>
                              <li>
                                <button data-bs-toggle="modal" id="articlePgDeleteBtn" data-bs-target="#deletePop"
                                  @click="setDeleteMode('single', article.slug), showAddForm = false, cancelEdit()">
                                  {{ constants.DELETE_BUTTON }}
                                </button>
                              </li>

                              <li><button id="articlePgUnPublishBtn" class="primary-outline-btn"
                                  v-if="article.status === 1" @click="changeArticleStatus(article.slug, 0)">
                                  {{ constants.UNPUBLISH_BUTTON }}
                                </button>
                                <button id="articlePgPublishBtn" class="primary-outline-btn"
                                  v-else-if="article.status === 0" @click="changeArticleStatus(article.slug, 1)">
                                  {{ constants.PUBLISH_BUTTON }}
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="admin-item-box-btm" v-if="article.editing">
                        <div class="add-banner-image-section">
                          <h2>
                            {{ constants.EDIT_ARTICLE_TEXT }}
                          </h2>
                          <div class="add-banner-image-box">
                            <div class="admin-input-field">
                              <label>
                                {{ constants.TITLE_LABEL }}
                              </label>
                              <input id="articleTitleInput" type="text" placeholder="Enter the Title"
                                v-model="editArticleData.title" />
                              <div class="error-msg" v-if="!editArticleData.title">{{ errEditMsg }}</div>
                            </div>
                            <div class="admin-input-field">
                              <label>
                                {{ constants.DESCRIPTION_LABEL }}
                              </label>
                              <ckeditor placeholder="Description" id="articleDescInput" class="text-editer"
                                :editor="editor" v-model="editArticleData.description" :config="Config">
                              </ckeditor>
                              <div class="error-msg" v-if="!editArticleData.description">{{ errEditMsg }}</div>
                            </div>
                            <div class="admin-input-field">
                              <label>
                                {{ constants.Article_IMAGE_LABEL }}
                              </label>
                              <div class="image-upload-input upload-banner-image">
                                <div class="image-upload-input-item uploaded-done">
                                  <div class="file-input-box">
                                    <button class="image-upload-input-item-delete-btn"
                                      type="button"
                                      @click="clearUploadedImage(true)"></button>
                                    <input id="editArticlefileInput" type="file" @change="handleFileUpload($event, true)"
                                    accept="image/jpeg,image/jpg,image/png" />
                                  </div>

                                  <div class="image-upload-input-item-uploaded">
                                    <img :src="editimageSrc || require('@/assets/images/admin-img/image-icon.svg')" alt="" />
                                  </div>

                                </div>
                              </div>
                              <div class="error-msg" v-if="!selectedEditFile && !editimageSrc">{{ errEditMsg }}</div>
                            </div>

                            <div class="admin-input-field-submit">
                              <button id="articleSubmitBtn" class="admin-btn-outline-primary"
                                @click="submitEditForm(article.slug)">
                                {{ constants.SUBMIT_BUTTON }}
                              </button>
                              <button id="articleCancelBtn" class="admin-btn-outline-secondary addNewCancel"
                                @click="cancelEdit">
                                {{ constants.CANCEL_BUTTON }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="admin-pagination-section">
                <div class="custom-row">
                  <div class="item-show-selectbox">
                    <select id="paginationSelectBox" v-model="limit" @change="handleLimitChange">
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                    <span> {{ constants.ENTRIES_PER_PAGE_LABEL }}</span>
                  </div>
                  <div class="admin-pagination" id="paginationBox" v-if="totalPages > 1">
                    <ul>
                      <li v-if="currentPage !== 1" @click="changePage(currentPage - 1)">
                        <a href="#" class="pagination-previous"></a>
                      </li>
                      <li v-for="page in visiblePages" :key="page" @click="changePage(page)" v-if="totalPages != 1">
                        <a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
                      </li>
                      <li v-if="currentPage !== totalPages" @click="changePage(currentPage + 1)">
                        <a href="#" class="pagination-next"></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <p>No data to display</p>
            </div>
          </div>
        </section>
      </div>
    </section>
    <footer class="admin-site-footer">
      <div class="container">
        {{ constants.COPYRIGHT_TEXT }}
      </div>
    </footer>
    <div class="modal fade confirmation-popup" id="deletePop" tabindex="-1" role="dialog"
      aria-labelledby="deleteModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="confirmation-popup-icon">
            <i>
              <img src="@/assets/images/admin-img/light_delete-outline.svg" alt="" />
            </i>
          </div>
          <div class="confirmation-popup-mid">
            <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
          </div>
          <div class="confirmation-popup-btm">
            <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal">
              {{ constants.NO_BUTTON }}
            </button>
            <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal" @click="confirmDelete">
              {{ constants.YES_BUTTON }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script lang="ts">
import { defineComponent, ref, nextTick } from 'vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import axios from 'axios';
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import Swal from 'sweetalert2';
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';
import Sortable, { SortableEvent } from 'sortablejs';
import { CustomUploadAdapterPlugin } from '@/utils/CustomUploadAdapterPlugin';
import {
  getPaginationLimit,
  setPaginationLimit,
} from "@/utils/paginationUtils";

interface Counts {
  all: number;
  published: number;
  unpublished: number;
}

interface Article {
  id: number;
  title: string;
  description: string;
  articleImage: string;
  status: number;
  editing?: boolean;
  Created_at?: string
  position: number; // Add position field,
  slug: string;

}

export default defineComponent({
  name: "Article",
  data() {
    return {
      constants,
      errMsg: '',
      errEditMsg: '',
      editor: ClassicEditor,
      activeTab: 'all',
      imageSrc: '',
      searchTempVar: '',
      editimageSrc: '',
      showAddForm: false,
      limit: 10,
      selectedFile: null as File | null,
      selectedEditFile: null as File | null,
      imageUploaded: false,
      selectAll: false,
      editFormSubmitted: false,
      articles: [] as Article[],
      editArticlesData: [] as Article[],
      selectedArticles: [] as string[],
      totalPages: 0,
      currentPage: 1,
      searchedText: '',
      counts: {
        all: 0,
        published: 0,
        unpublished: 0,
      } as any,
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'undo', 'redo', '|', 'insertTable', '||', 'imageUpload',
          ]
        },
      },
      newArticle: {
        title: '',
        description: '',
        articleImage: ''
      },
      editArticleData: {
        title: '',
        description: '',
        articleImage: ''
      },
      articleToDelete: null as string | null,
      deleteMode: 'all' as 'all' | 'single',
      isSubmitting: false,
      isDragging: false, //
      sortableInstance: null as Sortable | null, //
      sortBy: '-position' as string,
 
    };
  },
  beforeRouteEnter(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn !== "true") {
      next({ name: 'Login' });
    } else {
      next();
    }
  },
  computed: {

    Config(): any {
    return {
    extraPlugins: [CustomUploadAdapterPlugin],
    toolbar: {
    items: [
    'heading', '|',
    'bold', 'italic', 'link','underline', 'bulletedList', 'numberedList', '|',
    'outdent', 'indent', '|',
    'imageUpload', '|',
    'undo', 'redo', '|',
    'insertTable',
    ]
    },
    image: {
    toolbar: ['imageTextAlternative', 'imageStyle:full', 'imageStyle:side']
    }
    };
    },
    imageUrl(): string {
      return this.imageSrc || require('@/assets/images/admin-img/image-icon.svg');
    },
    editImage(): string {
      return this.editimageSrc || require('@/assets/images/admin-img/image-icon.svg');
    },
    visiblePages() {
      const maxVisiblePages = 5;
      const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
      let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
      let end = start + maxVisiblePages - 1;

      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(end - maxVisiblePages + 1, 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
  },
  components: {
    adminHeader,
    adminNavigation
  },
  created() {
    this.limit = getPaginationLimit("articles", 10);
    this.fetchCounts();
    this.fetchArticles();
  },
  mounted() {
    this.setupSortable(); // Initialize SortableJS on mount
  },
  methods: {
   
    setDeleteMode(mode: any, articleSlug?: string) {
      this.deleteMode = mode;
      if (articleSlug !== undefined) {
        this.articleToDelete = articleSlug;
      }
    },
    confirmDelete() {
      if (this.deleteMode === 'all') {
        this.deleteSelectedContacts();
      } else if (this.deleteMode === 'single') {
        this.deleteArticle();
      }
    },
    changePage(page: number) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchArticles(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        this.selectAll = false
        this.selectedArticles = []
      }
    },

    handleFileUpload(event: any, isEdit: boolean = false) {
      const target = event.target as HTMLInputElement;
      if (target && target.files && target.files.length > 0) {
        const file = target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          if (e.target && typeof e.target.result === 'string') {
            if (isEdit) {
              this.editimageSrc = e.target.result;
              this.selectedEditFile = file;
            } else {
              this.imageSrc = e.target.result;
              this.selectedFile = file;
              this.imageUploaded = true
            }
          }
        };
      }
    },
    toggleArticleSelection(articleSlug: string) {
      if (this.selectedArticles.includes(articleSlug)) {
        this.selectedArticles = this.selectedArticles.filter(id => id !== articleSlug);
      } else {
        this.selectedArticles.push(articleSlug);
      }


    },
    toggleSelectAll() {
      if (this.selectAll === true) {
        this.selectedArticles = [];
        this.selectAll = false
      } else {
        this.selectedArticles = this.editArticlesData.map(article => article.slug);
        this.selectAll = true
      }
    },

    async submitForm() {
    if (!this.newArticle.title || !this.newArticle.description || !this.selectedFile) {
        this.errMsg = "This Field Is Required";
        return;
    }
    this.isSubmitting = true;
    const formData = new FormData();
    formData.append('title', this.newArticle.title);
    formData.append('description', this.newArticle.description);
    formData.append('articleImage', this.selectedFile);

    try {
        const response = await fetch(`${API_BASE_URL}/article/`, {
            method: 'POST',
            body: formData
        });
        await response.json();
        this.resetForm();
        await this.fetchCounts(); // Fetch counts first
        // Adjust currentPage if needed
        if (this.counts[this.activeTab] > this.limit * this.currentPage) {
            this.currentPage = Math.ceil(this.counts[this.activeTab] / this.limit);
        }
        await this.fetchArticles(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Fetch articles with current limit
        this.imageUploaded = false;
        Swal.fire({
            icon: 'success',
            title: 'Article Created Successfully!',
            showConfirmButton: false,
            timer: 1500
        });
    } catch (error) {
        console.error('Error submitting article:', error);
    } finally {
        this.isSubmitting = false;
    }
},
async deleteSelectedContacts() {
    try {
        await axios.delete(`${API_BASE_URL}/article/bulk_delete/`, { data: { ids: this.selectedArticles } });
        this.editArticlesData = this.editArticlesData.filter(article => !this.selectedArticles.includes(article.slug));
        this.selectedArticles = [];
        await this.fetchCounts(); // Update counts
        await this.fetchArticles(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Refresh articles
        if (this.editArticlesData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchArticles(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        this.selectAll = false;
    } catch (error) {
        console.error('Error deleting contacts:', error);
    }
},
    async submitEditForm(articleSlug: string) {
      if (!this.editArticleData.title || !this.editArticleData.description || (!this.selectedEditFile && !this.editimageSrc)) {
        this.errEditMsg = 'This Field Is Required'
        return
      }
      const formData = new FormData();
      formData.append('title', this.editArticleData.title);
      formData.append('description', this.editArticleData.description);
      if (this.selectedEditFile) {
        formData.append('articleImage', this.selectedEditFile);
      }

      try {
        const response = await axios.patch(`${API_BASE_URL}/article/${articleSlug}/`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        this.fetchArticles();
        this.cancelEdit();
        this.editFormSubmitted = false;
        Swal.fire({
          icon: 'success',
          title: 'Article Updated Successfully!',
          showConfirmButton: false,
          timer: 1500
        });
      } catch (error) {
        console.error('Error updating article:', error);
      }
    },

    handleLimitChange() {
    setPaginationLimit("articles", this.limit);
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
    this.selectAll = false;
    this.selectedArticles = [];
    this.fetchArticles(this.activeTab, this.limit, 0);
},
    //@ts-expect-error
    async fetchArticles(status = 'all', limit?: number, skip = 0, sortBy = this.sortBy){  
    
    const effectiveLimit = limit ?? this.limit;
   

    let url = `${API_BASE_URL}/article/`;
    const params = new URLSearchParams();
    if (status === 'published') params.append('status', '1');
    else if (status === 'unpublished') params.append('status', '0');

    // Only reset currentPage for a new search, preserve limit
    if (this.searchedText && !this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = this.searchedText;
    }
    if (!this.searchedText && this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = '';
    }

    params.append('limit', effectiveLimit.toString());
    params.append('skip', skip.toString());
    if (this.searchedText) {
        params.append('searchedText', this.searchedText);
    }
    params.append('sort_by', sortBy);

    try {
        const response = await axios.get(`${url}?${params.toString()}`);
        this.editArticlesData = response.data;
        this.totalPages = Math.ceil(this.counts[status] / effectiveLimit); // Update totalPages
        console.log('Articles Fetched:', this.editArticlesData.length, 'Total Pages:', this.totalPages); // Debug log
        this.setupSortable();
    } catch (error) {
        console.error('Error fetching articles:', error);
    }
},
async switchView(status: string) {
    this.currentPage = 1;
    this.activeTab = status;
    this.selectedArticles = [];
    this.selectAll = false;
    this.editFormSubmitted = false;
    await this.fetchArticles(status, this.limit, 0); // Use current limit
    if (status === 'published') {
        this.totalPages = Math.ceil(this.counts.published / this.limit);
    } else if (status === 'unpublished') {
        this.totalPages = Math.ceil(this.counts.unpublished / this.limit);
    } else {
        this.totalPages = Math.ceil(this.counts.all / this.limit);
    }
},
    async fetchCounts(searchedText?: string) {
      try {
        const baseUrl = `${API_BASE_URL}/article/count/`;
        const queryParam = searchedText ? `?searchedText=${searchedText}&status=` : '?status=';
        const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
          axios.get(`${baseUrl}${queryParam}0&status=1`),
          axios.get(`${baseUrl}${queryParam}1`),
          axios.get(`${baseUrl}${queryParam}0`)
        ]);

        this.counts = {
          all: allResponse.data.count,
          published: publishedResponse.data.count,
          unpublished: unpublishedResponse.data.count
        };

        if (this.activeTab in this.counts) {
          this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
        } else {
          console.error(`Invalid active tab: ${this.activeTab}`);
        }
      } catch (error) {
        console.error('Error fetching article counts:', error);
      }
    },


    editArticle(index: number) {
      this.editArticlesData.forEach((article, i) => {
        article.editing = i === index;
      });
      this.editFormSubmitted = true;
      const selectedArticle = this.editArticlesData[index];
      this.editArticleData = {
        title: selectedArticle.title,
        description: selectedArticle.description,
        articleImage: selectedArticle.articleImage || ''
      };
      // this.editimageSrc = selectedArticle.articleImage || '';


      // Use getCdnImageAddress to ensure proper CDN URL
      this.editimageSrc = selectedArticle.articleImage
        ? this.getCdnImageAddress(selectedArticle.articleImage, 'w_200,h_100/')
        : '';


      // Disable SortableJS while editing
      if (this.sortableInstance) {
        this.sortableInstance.option('disabled', true);
      }
    },

    resetForm() {
      this.newArticle = {
        title: '',
        description: '',
        articleImage: ''
      };
      this.selectedFile = null;
      this.imageSrc = '';
      this.showAddForm = false;
      this.errMsg = '';
      this.imageUploaded = false;
    },

    cancelEdit() {
      this.editArticlesData.forEach((article) => {
        article.editing = false;
      });
      this.editArticleData = {
        title: '',
        description: '',
        articleImage: ''
      };
      this.editFormSubmitted = false;
      this.selectedEditFile = null;
      this.editimageSrc = '';
      this.errEditMsg = '';
      // Re-enable SortableJS after canceling edit
      if (this.sortableInstance) {
        this.sortableInstance.option('disabled', false);
      }
    },

    async deleteArticle() {
    try {
        await axios.delete(`${API_BASE_URL}/article/${this.articleToDelete}/`);
        await this.fetchCounts(); // Update counts
        await this.fetchArticles(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Refresh articles
        if (this.editArticlesData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchArticles(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        (this.$refs.dummyButton as HTMLElement)?.click();
    } catch (error) {
        console.error('Error deleting article:', error);
    }
},

async changeArticleStatus(articleSlug:string, newStatus: number) {
    try {
        const formData = new FormData();
        formData.append('status', newStatus.toString());

        await axios.patch(`${API_BASE_URL}/article/${articleSlug}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        await this.fetchCounts(); // Update counts
        await this.fetchArticles(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Refresh articles
        if (this.editArticlesData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchArticles(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
    } catch (error) {
        console.error('Error updating article status:', error);
    }
},
    getCdnImageAddress(src: string, size: string): string {
        if (!src) return '';
        let cdnUrl: string = environment.imageCdn.getHost;
        cdnUrl = cdnUrl.concat(size);
        return cdnUrl + encodeURIComponent(src);
    },
    useStripHtml(html : string) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
    },
    setupSortable() {
      nextTick(() => {
        const sortableList = this.$refs.sortableList as HTMLElement;
        if (!sortableList) {
          console.error('Sortable list ref not found!');
          return;
        }

        if (this.sortableInstance) {
          this.sortableInstance.destroy();
        }

        this.sortableInstance = Sortable.create(sortableList, {
          animation: 150,
          draggable: '.admin-item-box',
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          dragClass: 'sortable-drag',
          filter: '.css-checkbox, button, input, select, textarea, a, .ck-editor, .ck-content', // Expanded filter
          preventOnFilter: true,
          disabled: this.editFormSubmitted,
          onStart: (evt: SortableEvent) => {
            this.isDragging = true;
            if (['title', '-title', 'description', '-description'].includes(this.sortBy)) {
              evt.preventDefault();
              Swal.fire({
                icon: "warning",
                title: "Cannot Drag",
                text: "First remove sorting then you can be able to drag   it.",
                timer: 2000,
                showConfirmButton: false,
              });
              return false;
            }
          },
          onEnd: async (evt: SortableEvent) => {
            this.isDragging = false;
            const oldIndex = evt.oldIndex!;
            const newIndex = evt.newIndex!;

            if (oldIndex === newIndex) return;

            // Optimistically update local data
            const newArticlesData = [...this.editArticlesData];
            const [movedItem] = newArticlesData.splice(oldIndex, 1);
            newArticlesData.splice(newIndex, 0, movedItem);

            
            const totalItems = newArticlesData.length;
            newArticlesData.forEach((item, index) => {
            item.position = totalItems - index; // Highest position for top item
            });

            // Update reactive property
            this.editArticlesData = newArticlesData;

            // Prepare data for backend sync
            const reorderedItems = newArticlesData.map((item) => ({
              id: item.id,
              position: item.position,
            }));

            try {
              console.log(reorderedItems,'hhhhhhhhhh')
              await axios.post(`${API_BASE_URL}/article/reorder/`, {
                items: reorderedItems,
              });

              // Fetch updated data from server
              await this.fetchArticles(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);

              Swal.fire({
                icon: 'success',
                title: 'Order Updated Successfully!',
                timer: 1500,
                showConfirmButton: false,
              });
            } catch (error) {
              console.error('Error updating order:', error);
              await this.fetchArticles(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
              Swal.fire({
                icon: 'error',
                title: 'Order Update Failed!',
                text: 'Reverted to last saved order.',
                showConfirmButton: false,
                timer: 1500,
              });
            }
          },
        });

        console.log('Sortable instance created:', this.sortableInstance);
    });
},

clearUploadedImage(isEdit: boolean) {
		if (isEdit) {
      this.editimageSrc = '';
      this.selectedEditFile = null;
      const fileInput = document.getElementById('editArticlefileInput') as HTMLInputElement;
      if (fileInput) {
          fileInput.value = '';
      }
		} else {
			this.imageSrc = '';
      this.selectedFile = null;
      this.imageUploaded = false;
      const fileInput = document.getElementById('addArticlefileInput') as HTMLInputElement;
      if (fileInput) {
          fileInput.value = '';
      }
		}
	},

   toggleSort(field: string) {
            if (this.sortBy === field) {
                this.sortBy = `-${field}`; 
            } else if (this.sortBy === `-${field}`) {
                this.sortBy = '-position'; 
            } else {
                this.sortBy = field; 
            }
            this.fetchArticles(this.activeTab, this.limit, (this.currentPage - 1) * this.limit, this.sortBy);
        },

 },  

});
</script>

<style scoped>
.admin-item-box-top {
  cursor: move;
}
.admin-item-box.dragging {
  opacity: 0.5;
}
</style>